import { _ as _object_spread } from "@swc/helpers/_/_object_spread";
import { applyMiddleware } from 'redux';
import { createStore } from 'redux-dynamic-modules-core';
import { getSagaExtension } from 'redux-dynamic-modules-saga';
import { composeWithDevTools } from '@redux-devtools/extension';
import ddt from '@wix/da-ddt';
import { shouldLogError } from '@wix/da-react-context/pkg/ErrorBoundary/ErrorBoundary';
export function rootModuleStoreFactory(middlewares, logger, initialState, rootReducer, rootSaga, useOld = true) {
    var _initialState_flags;
    // @ts-ignore
    const sagaExt = getSagaExtension(undefined, (error, stack)=>{
        logger.error('Uncaught error in saga', error, stack);
        if (!shouldLogError(error)) {
            return;
        }
        ddt.alert('redux', `Saga crashed: ${error && error.message || 'unknown'}`, [
            'fatal'
        ], {
            stacktrace: error && error.stack,
            sagastack: stack
        });
    });
    let devtoolsConfig = {};
    if (initialState && ((_initialState_flags = initialState.flags) === null || _initialState_flags === void 0 ? void 0 : _initialState_flags.hasOwnProperty('redux_action_trace'))) {
        devtoolsConfig = {
            trace: true,
            traceLimit: 25
        };
    }
    const store = createStore({
        initialState,
        extensions: [
            sagaExt
        ],
        enhancers: [
            applyMiddleware(...middlewares)
        ],
        advancedComposeEnhancers: composeWithDevTools(devtoolsConfig)
    }, getRootModule(rootReducer, rootSaga));
    return store;
}
function getRootModule(rootReducer, rootSaga) {
    return {
        id: 'rootModule',
        reducerMap: _object_spread({}, rootReducer),
        sagas: [
            rootSaga
        ],
        retained: true
    };
}
